import { render, staticRenderFns } from "./DTPLists.vue?vue&type=template&id=12b99b7d&"
import script from "./DTPLists.vue?vue&type=script&lang=js&"
export * from "./DTPLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports